import { useDisclosure } from '@chakra-ui/react';

import { useGlobalModalsContext } from 'contexts/globalModalsContext';
import Icon from 'ui/Icon';
import Menu, { MenuItemProps } from 'ui/Menu';

import { useCurrentUser } from '../../utils/user';
import ManageSubscriptionModal from './ManageSubscriptionModal';

type Props = MenuItemProps & {
  label: string;
  badge?: React.ReactNode;
  conversionTriggerAction: string;
  upgradeMessage?: string;
};

const BlockedMenuItem: React.FC<Props> = ({
  label,
  badge,
  conversionTriggerAction,
  upgradeMessage,
  ...props
}) => {
  const { openConversionModal } = useGlobalModalsContext();
  const { open, onOpen, onClose } = useDisclosure();
  const { user } = useCurrentUser();

  const content = (
    <>
      {label} <Icon fontSize="sm" icon="crown" opacity={0.8} /> {badge}
    </>
  );

  // Show the subscribe modal if the user is not subscribed (or not even signed in)
  if (!user?.has_active_subscription) {
    return (
      <Menu.Item
        onClick={() => openConversionModal(conversionTriggerAction)}
        {...props}
      >
        {content}
      </Menu.Item>
    );
  }

  // If the upgrade message is present show it
  if (upgradeMessage) {
    return (
      <>
        <Menu.Item onClick={onOpen} {...props}>
          {content}
        </Menu.Item>
        <ManageSubscriptionModal
          open={open}
          onClose={onClose}
          message={upgradeMessage}
          buttonText="Manage subscription"
        />
      </>
    );
  }

  // Otherwise don't show the menu item at all
  return null;
};

export default BlockedMenuItem;
